const toolService = {
  checkRates: async () => {},
};

export default toolService;
